// ABOUTME: notifyError(error) — the one way to tell the user something failed: translated server codes,
// ABOUTME: a network message for failed requests, a generic message for the rest. Never raw technical text.
import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { userErrorMessage } from "@/graphql/client/errorMessage"
import { useNotificationContext } from "./useNotificationContext"

const ERROR_TOAST_MS = 3000

export const useErrorNotifier = () => {
  const { t } = useTranslation()
  const { handleNotification } = useNotificationContext()
  const notifyError = useCallback(
    (error: unknown) => {
      handleNotification("error", userErrorMessage(error, t), true, ERROR_TOAST_MS)
    },
    [handleNotification, t],
  )
  return { notifyError }
}
